// ** Custom Components
import AboutUsItem from "./AboutUsItem";

// ** Import Content
import aboutUsContent from "../aboutUsContent";

// ** Styles Import
import { StyledCol as Col } from "styles/components/Col.styled";

// #####################################################

const AboutUsSection = () => {
	return aboutUsContent.map(({ quote, link, linkName, data, author }) => (
		<Col sm={12} md={6} xl={4} key={link}>
			<AboutUsItem
				quote={quote}
				link={link}
				linkName={linkName}
				data={data}
				author={author}
			/>
		</Col>
	));
};

export default AboutUsSection;
